import React from "react";
import { Table, Button } from "react-bootstrap";

const isNonEmpty = (val) =>
  val !== null && val !== undefined && String(val).trim() !== "";

const isEmpty = (val) => !isNonEmpty(val);

// Row-level rule: allowed to edit when bpId is TBA and amount is empty
const canEditRow = (client) =>
  client?.bpId === "To be Assigned" && isEmpty(client?.amount);

const ClientTable = ({ clients = [], onEdit, editDisabled = false }) => {
  // Show the Reference column only if at least one client has a non-empty referenceNo
  const showReferenceCol = clients.some((c) => isNonEmpty(c?.referenceNo));

  // Show the Actions column only if at least one row qualifies for editing
  const showActionsCol = clients.some(canEditRow);

  return (
    <Table bordered hover>
      <thead>
        <tr>
          <th>Client's Name</th>
          <th>BPID</th>
          <th>ISIN</th>
          {showReferenceCol && <th>e-SIP Reference No.</th>}
          <th>Amount</th>
          {showActionsCol && <th style={{ width: 140 }}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {clients.map((client, index) => {
          const rowCanEdit = canEditRow(client);

          return (
            <tr key={client?.id ?? index}>
              <td>{client?.name ?? "—"}</td>
              <td>{client?.bpId ?? "—"}</td>
              <td>{client?.isin ?? "—"}</td>

              {showReferenceCol && (
                <td>{isNonEmpty(client?.referenceNo) ? client.referenceNo : "—"}</td>
              )}

              <td>{isEmpty(client?.amount) ? "—" : client.amount}</td>

              {showActionsCol && (
                <td>
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={() => onEdit?.(client)}
                    disabled={!rowCanEdit || editDisabled}
                    title={
                      !rowCanEdit
                        ? 'Available only when BPID is "To be Assigned" and Amount is empty'
                        : undefined
                    }
                  >
                    Edit
                  </Button>
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default ClientTable;